import {isObject} from "lodash";
import cartApi from '@support/cartApi'

const state = {
    checkoutLoaded: false,
    data: {
        products: {},
        total: null,
        subtotal: null,
        tax_total: null,
    },
};

const getters = {
    isHasProducts: (state, getters, rootState) => {
        return !!(isObject(state.data.products) ? Object.keys(state.data.products).length : false);
    },
    cartProducts: (state, getters, rootState) => {
        return state.data.products || {};
    },
    cartTotalPrice: (state, getters) => {
        return state.data.total || 0;
    },
    cartSubTotal: (state, getters) => {
        return state.data.subtotal;
    },
    cartTaxTotal: (state, getters) => {
        return state.data.tax_total;
    },
    cartShippingTotal: (state, getters) => {
        return state.data.shipping_total;
    },
    cartTotalProducts: (state, getters) => {
        let total = 0;

        for (let rowId in state.data.products) {
            let product = state.data.products[rowId];
            total += parseInt(product.qty);
        }

        return total;
    },
};

const actions = {
    loadCheckout: function (context) {
        context.commit('setCheckoutLoaded', false);
        cartApi.getCart()
            .then((response) => {
                context.commit('setData', response.data);
            })
            .catch((error) => {
                console.error(error);
            })
            .then(() => {
                context.commit('setCheckoutLoaded', true);
            });
    },
};

const mutations = {
    setCheckoutLoaded(state, isLoaded) {
        state.checkoutLoaded = !!isLoaded;
    },
    setData(state, data) {
        state.data = data;
    },
    setProducts(state, products) {
        state.data.products = products;
    },
    setTotal(state, total) {
        state.data.total = total;
    },
    setSubTotal(state, subTotal) {
        state.data.subtotal = subTotal;
    },
    setTaxTotal(state, taxTotal) {
        state.data.tax_total = taxTotal;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
